// TODO: see what other constants we should start moving here
export const GBLI_PHONE_EVENTS = "800-310-3351";
export const GBLI_PHONE_EVENTS_TITLE = "800-310-3351, option 2";
export const GBLI_EMAIL_EVENTS = "info@gblievents.com";
export const GBLI_FAX_CLAIMS = "610-660-8885";
export const GBLI_EMAIL_CLAIMS = "claims@global-indemnity.com";
